import { CategoryId } from '~/models/category/types'
import { PropType } from '~/utils/nuxt3-migration'
import { Facet } from '~/models/search/types'

export const facetHandlerComponentProps = {
  humanName: {
    type: String,
    required: true
  },
  isImportant: {
    type: Boolean,
    default: false
  },
  isOpen: {
    type: Boolean,
    default: false
  },
  isSelected: {
    type: Boolean,
    default: false
  },
  searchables: {
    type: [Array, Object],
    default() {
      return []
    }
  },
  humanParams: {
    type: Array,
    default() {
      return []
    }
  },
  params: {
    type: Array,
    default() {
      return []
    }
  },
  selected: {
    type: [Array, Object],
    default: null
  },
  allValues: {
    type: Object,
    required: true
  },
  strictValues: {
    type: Boolean,
    default: false
  },
  urlArgNames: {
    type: Array,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  type: {
    type: String,
    required: true
  },
  isMultiselect: {
    type: Boolean,
    default: false
  },
  value: {
    type: [Object, Boolean, String, Number],
    default: null
  },
  defaultCategory: {
    type: Number,
    default: CategoryId.CLASSIFIEDS
  },
  handler: {
    type: Object as PropType<Facet>,
    required: true
  },
  searchPlaceholder: {
    type: String,
    default: null
  },
  variant: {
    type: Object,
    default() {
      return {}
    }
  },
  isNested: {
    type: Boolean,
    default: false
  },
  noPortal: {
    type: Boolean,
    default: false
  }
}
